import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/** The rep's value differs from the calculated one by more than a dollar. The rep's
 *  number is what the deal shows; the chip says the two disagree — either the
 *  calculation is missing work, or the ServiceTitan project was never updated. */
export function ValueMismatchChip({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" className={cn("font-normal text-warning-ink", className)}>
          Rep value differs
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        The rep's value differs from the calculated value. Check the ServiceTitan project is up to date.
      </TooltipContent>
    </Tooltip>
  );
}
